import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { homeownerPost } from '../utils/homeownerApi';
import { useChrome } from './ceo/ceoChrome';

export default function AnnouncementBanner({ audience, colors, previewItems }) {
  const chrome = useChrome(colors || {}, false);
  const [items, setItems] = useState(previewItems || []);

  useEffect(() => {
    if (previewItems) {
      setItems(previewItems);
      return undefined;
    }
    let live = true;
    async function load() {
      try {
        if (audience === 'homeowner') {
          const data = await homeownerPost('/.netlify/functions/homeowner-announcements', { action: 'list' });
          if (live) setItems((data && data.announcements) || []);
          return;
        }
        const result = await supabase.rpc('visible_announcements');
        if (live && !result.error) setItems(result.data || []);
      } catch (error) {
        if (live) setItems([]);
      }
    }
    load();
    return () => { live = false; };
  }, [audience, previewItems]);

  async function dismiss(item) {
    setItems((current) => current.filter((row) => row.id !== item.id));
    if (previewItems) return;
    try {
      if (audience === 'homeowner') {
        await homeownerPost('/.netlify/functions/homeowner-announcements', { action: 'dismiss', id: item.id });
      } else {
        await supabase.rpc('dismiss_announcement', { p_id: item.id });
      }
    } catch (error) {
      // The card is already hidden. A failed dismiss shows it again next visit.
    }
  }

  if (!items.length) return null;
  const releases = items.filter((item) => item.kind === 'release');
  const banners = items.filter((item) => item.kind !== 'release');

  return (
    <div
      data-testid="announcement-banner"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        paddingTop: 'env(safe-area-inset-top, 0px)',
        paddingLeft: 'calc(env(safe-area-inset-left, 0px) + 16px)',
        paddingRight: 'calc(env(safe-area-inset-right, 0px) + 16px)',
      }}
    >
      {banners.map((item) => (
        <div key={item.id} style={{ ...chrome.panel, display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontWeight: 600 }}>{item.title}</div>
            <div style={{ color: chrome.secondary, marginTop: 4 }}>{item.body}</div>
          </div>
          {item.dismissible !== false ? (
            <button type="button" onClick={() => dismiss(item)} style={chrome.quiet}>Dismiss</button>
          ) : null}
        </div>
      ))}
      {releases.map((item) => (
        <div key={item.id} style={chrome.panel}>
          <div style={{ color: chrome.secondary, fontSize: 13 }}>What's new</div>
          <div style={{ fontWeight: 600, fontSize: 18, marginTop: 4 }}>{item.title}</div>
          <div style={{ color: chrome.secondary, marginTop: 6 }}>{item.body}</div>
          {item.dismissible !== false ? (
            <button type="button" onClick={() => dismiss(item)} style={{ ...chrome.quiet, marginTop: 12 }}>Dismiss</button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
